import React from "react";
import KamAssignment from "./KamAssignment";
import { useCandidateKamAssignment } from "../hooks/candidate/useCandidateKamAssignment";
import { getCurrentUser } from "../utils/auth";

interface CandidateKamAssignmentProps {
  candidateId: number;
}

const CandidateKamAssignment: React.FC<CandidateKamAssignmentProps> = ({
  candidateId,
}) => {
  const user = getCurrentUser();
  const hook = useCandidateKamAssignment({
    candidateId,
    userRole: user?.role || "",
    enabled: !!candidateId,
  });

  return <KamAssignment hook={hook} />;
};

export default CandidateKamAssignment;
